import { AuthRequest, Prompt, ResponseType } from 'expo-auth-session';
import { Platform } from 'react-native';

export const KEYCLOAK_URL = process.env.EXPO_PUBLIC_KEYCLOAK_URL;
export const KEYCLOAK_REDIRECT_URL = Platform.select({
  default: process.env.EXPO_PUBLIC_KEYCLOAK_NATIVE_REDIRECT_URL,
  web: process.env.EXPO_PUBLIC_KEYCLOAK_WEB_REDIRECT_URL
});

export const KEYCLOAK_CLIENT_ID = process.env.EXPO_PUBLIC_KEYCLOAK_CLIENT_ID;
export const KEYCLOAK_CLIENT_SCOPES = [
  'openid',
  'profile',
  'email',
  'offline_access'
];
export const KEYCLOAK_LOGOUT_URL = `${KEYCLOAK_URL}/protocol/openid-connect/logout?client_id=${KEYCLOAK_CLIENT_ID}&id_token_hint=`;
export const KEYCLOAK_REGISTRATION_URL = `${KEYCLOAK_URL}/protocol/openid-connect/registrations?client_id=${KEYCLOAK_CLIENT_ID}&scope=${KEYCLOAK_CLIENT_SCOPES.join('%20')}&redirect_uri=${KEYCLOAK_REDIRECT_URL}&response_type=code`;
export const KEYCLOAK_USER_INFO_URL = `${KEYCLOAK_URL}/protocol/openid-connect/userinfo`;
export const KEYCLOAK_CHANGE_PASSWORD_URL = `${KEYCLOAK_URL}/login-actions/reset-credentials`;

export const KEYCLOAK_AUTH_REQUEST = new AuthRequest({
  responseType: ResponseType.Code,
  clientId: KEYCLOAK_CLIENT_ID,
  redirectUri: KEYCLOAK_REDIRECT_URL,
  prompt: Prompt.Login,
  scopes: KEYCLOAK_CLIENT_SCOPES,
  state: Math.random().toString(36).slice(2, 15),
  usePKCE: true
});
